import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { 
  Typography, 
  Divider, 
  Box, 
  CircularProgress,
  Container,
  Card,
  CardContent
} from '@mui/material';
import { styled } from '@mui/material/styles';
// import { InsertDriveFile, CheckCircle, Schedule, OpenInNew } from '@mui/icons-material';
import { quizService } from '../../services/api';

// Styled components using MUI v5 styled API
const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
}));

const LoadingContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50vh',
  '& > p': {
    marginTop: theme.spacing(2),
  },
}));

const QuizPreview = () => {
const params = useParams();
const quizId = params.quizId || '0';
const courseId = params.courseId || '0';
const ccrId = params.ccrId || '0';
  //const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [quiz, setQuiz] = useState(null);
  const [error, setError] = useState(null);
  
  // Check if this is an independent view (no layout)
  const isIndependentView = location.search.includes('independent=true');

  useEffect(() => {
    const fetchQuizData = async () => {
      try {
        setLoading(true);
        const response = await quizService.getQuizPreview(quizId, courseId, ccrId);
        setQuiz(response.data.data);
      } catch (err) {
        console.error('Error fetching quiz preview:', err);
        setError('Failed to load quiz preview');
      } finally {
        setLoading(false);
      }
    };

    fetchQuizData();
  }, [quizId, courseId, ccrId]);

  
  const openIndependentView = () => {
    const url = `/quiz/preview/${quizId}?independent=true`;
    window.open(url, '_blank');
  };

  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress />
        <Typography variant="body1">Loading Quiz preview...</Typography>
      </LoadingContainer>
    );
  }

  if (error || !quiz) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography variant="h6" color="error" align="center">
          {error || 'Quiz not found'}
        </Typography>
      </Container>
    );
  }

  const quizContent = (
    <StyledCard>
      <CardContent>
        <Typography variant="h1" gutterBottom>
          {quiz.title}
        </Typography>
  
        {quiz.question_cnt > 0 && (
          <>
            {quiz.time_limit_req && quiz.time_limit > 0 && (
              <>
                <Typography variant="body1" color="text.secondary">
                  Duration is {quiz.time_limit} Minutes.
                </Typography>
                <Divider sx={{ my: 2 }} />
              </>
            )}
  
            <Box
              sx={{ mb: 3, fontSize:'1.25rem'}}
              dangerouslySetInnerHTML={{ __html: quiz.description}}
            />
            <Box textAlign="center" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <a
                href={`/quiz/start/${quiz.id}/${courseId}/${ccrId}`}
                className="btn btn-info"
                style={{ padding: '10px 20px', fontSize: '1rem', textDecoration: 'none', borderRadius: 4, backgroundColor: '#E0115F', color: '#fff' }}
              >
                Let's Start
              </a>
            </Box>
          </>
        )}
      </CardContent>
    </StyledCard>
  );
  // If this is an independent view, render without the main layout
  if (isIndependentView) {
    return (
      <Box sx={{ 
        p: 3, 
        minHeight: '100vh',
        bgcolor: '#f5f5f5'
      }}>
        <Container maxWidth="lg">
          {quizContent}
        </Container>
      </Box>
    );
  }

  // Otherwise, render normally (will be wrapped in the main layout)
  return (
    <Container sx={{ py: 4 }}>
      {quizContent}
    </Container>
  );
};

export default QuizPreview;